import { render, staticRenderFns } from "./ExportarLicencias.vue?vue&type=template&id=14388610"
import script from "./ExportarLicencias.vue?vue&type=script&lang=js"
export * from "./ExportarLicencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports